import { LOCATION_CHANGE } from 'connected-react-router'

const initialState = {
  submitting: false,
  successful: false
}

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case LOCATION_CHANGE: {
      return initialState
    }
    case 'SEND_QUOTE' : {
      return {
        ...state,
        submitting: true,
      }
    }
    case 'SEND_QUOTE_COMMIT' : {
      return {
        ...state,
        successful: true,
        submitting: false
      }
    }
    case 'SEND_QUOTE_ROLLBACK' : {
      return {
        ...state,
        successful: false,
        submitting: false
      }
    }
    default: {
      return state
    }
  }
}
